// components/FeaturedBottom.tsx
import React from "react";
import Link from "next/link";
import Image from "next/image";

interface FeaturedBottomProps {
  blok?: any;
}

const FeaturedBottom: React.FC<FeaturedBottomProps> = ({ blok }) => {
  if (!blok) return null;

  const {
    title,
    topics,
    slug,
    author_name,
    author_photo,
    data_filter,
    data_topic,
  } = blok || {};

  const blogUrl = `/articles/${slug}`;
  const imageUrl = blok?.thumb?.filename || blok?.thumb || "";

  return (
    <Link
      href={blogUrl}
      className="blog-preview blog-result-0 card card-lighter scroll-trigger text-dark"
      data-filter={data_filter || title}
      data-topic={data_topic || topics?.toLowerCase()?.replace(/\s/g, "-")}
    >
      <div className="blog-preview-image position-relative overflow-hidden">
        {imageUrl && (
          <Image
            src={imageUrl}
            alt={typeof title === 'string' ? title : ''}
            fill
            className="object-fit-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        {topics && <span className="blog-preview-tag">{topics}</span>}
      </div>
      <div className="blog-preview-content p-3 p-lg-4">
        <h3
          className="title blog-preview-text mb-3"
          dangerouslySetInnerHTML={{
            __html: typeof title === "string" ? title : "",
          }}
        ></h3>
        {author_photo && (
        <p className="blog-preview-note mb-3">
          {author_photo && (
            <Image
              src={author_photo}
              width={30}
              height={30}
              alt=""
              className="rounded-circle me-1 js-lazy-load"
              data-src={author_photo}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="lazy"
              quality={75}
            />
          )}
          {author_name}
        </p>
        )}
        <p className="blog-preview-link mb-0">
          <span className="d-block btn btn-primary">Read More</span>
        </p>
      </div>
    </Link>
  );
};

export default FeaturedBottom;
